import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProducts, getProductDetail } from "../../features/product";
import { ProductCard } from "../../components/ProductCard";
import { NoData } from "../../components/common/NoData";
import { useNavigate } from "react-router-dom";
import { getExcelDate, getISOFormattedDate } from "../../utils/commonHelper";
import { DynamicFormModal } from "../../components/common/dynamic-form-modal";
// import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import { Loader } from "../../components/common/loader";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Insuranceimage1 from "../../assets/images/insurance-slider/01.jpg";
import Insuranceimage2 from "../../assets/images/insurance-slider/02.jpg";
import Insuranceimage3 from "../../assets/images/insurance-slider/03.jpg";
import Insuranceimage4 from "../../assets/images/insurance-slider/04.jpg";
import { Image } from "react-bootstrap";
const ProductContainer = ({ isAllProductPage }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const productContainerSideData = t("productContainerSideData", {
    returnObjects: true,
  });

  const [activeProduct, setActiveProduct] = useState(0);
  const [activeSubProduct, setActiveSubProduct] = useState(null);
  const [subProducts, setSubProducts] = useState([]);
  const { productLoader, products, homeProducts, productDetail } = useSelector(
    (state) => state.product
  );
  const [formData, setFormData] = useState({});
  const [askMemberDetailForm, setAskMemberDetailForm] = useState(false);
  const askMemberDetailFormData = [
    {
      input_label: "Member First Name",
      input_type: "text",
      is_mandatory: "1",
    },
    {
      input_label: "Member Last Name",
      input_type: "text",
      is_mandatory: "1",
    },
    {
      input_label: "Member Dob",
      input_type: "date",
      is_mandatory: "1",
    },
    {
      input_label: "Member Pass Num",
      input_type: "text",
      is_mandatory: "1",
    },
    {
      input_label: "Member Gender",
      input_type: "select",
      is_mandatory: "1",
      option_paremeter: [
        {
          option_label: "Male",
          option_value: "Male",
        },
        {
          option_label: "Female",
          option_value: "Female",
        },
        {
          option_label: "Other",
          option_value: "Other",
        },
      ],
    },
  ];
  // const [askMemberDetailFormData, setAskMemberDetailFormData] = useState({
  //     "member_first_name": "Obulakshmi",
  //     "member_last_name": "V",
  //     "member_dob": 35376,
  //     "member_pass_num": "SX1234567",
  //     "member_gender": "Female",
  //     "member_group_rate": 6.388,
  //     "index": 0
  // });

  useEffect(() => {
    dispatch(getProducts());
    // // console.log({ homeProducts });
  }, [dispatch]);

  const getSubProducts = useCallback(
    (productId) => {
      const product = products.find((p) => p.id === productId);
      return product ? product.sub_products : [];
    },
    [products]
  ); // depends only on products

  useEffect(() => {
    const subProducts = getSubProducts(activeProduct);
    setSubProducts(subProducts);
  }, [activeProduct, getSubProducts]);

  const handleProductClick = (product) => {
    // // console.log(product, 'product');
    setActiveProduct(product?.id);
    localStorage.setItem(
      "product_details",
      JSON.stringify({
        product_id: product?.id,
        sub_product_id: product?.sub_products[0]?.id,
      })
    );
    if (product?.has_company) {
      navigate(`/product/${product?.product_name}`, {
        state: {
          subProductsTemp: product?.sub_products,
        },
      });
    } else {
      navigate(`/product/${product?.product_name.replaceAll(" ", "-")}`);
    }
  };

  const handleSubProductClick = (data, index) => {
    setActiveSubProduct(index);
    localStorage.setItem("product_details", JSON.stringify(data));
    dispatch(getProductDetail(data));
  };

  useEffect(() => {
    if (subProducts && subProducts.length) {
      let product_detail_req_data = JSON.parse(
        localStorage.getItem("product_details")
      );
      dispatch(getProductDetail(product_detail_req_data));
    }
  }, [dispatch, subProducts]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const submitGetQuote = (e) => {
    e.preventDefault();
    let startInputDate = getExcelDate();

    if (formData && formData.no_of_persons) {
      setAskMemberDetailForm(true);
    } else {
      navigate("/company-list", {
        state: {
          ropRequestData: {
            form_data: {
              ...formData,
              prev_policy_exp_date: startInputDate - 1,
              policy_start_input_date: startInputDate,
              start_excel_date: getExcelDate(formData?.start_date),
              end_excel_date: getExcelDate(formData?.end_date),
              today_iso_date: getISOFormattedDate(),
              yesterday_iso_date: getISOFormattedDate(-1),
              tomorrow_iso_date: getISOFormattedDate(1),
              name: "Test",
            },
            product_details: JSON.parse(
              localStorage.getItem("product_details")
            ),
          },
        },
      });
    }
  };

  const handleAskMemberDetailFormSubmit = (e, displayFormData) => {
    e.preventDefault();
    let startInputDate = getExcelDate();

    // // console.log(displayFormData);
    navigate("/company-list", {
      state: {
        ropRequestData: {
          form_data: {
            ...formData,
            mem_details: displayFormData,
            prev_policy_exp_date: startInputDate - 1,
            policy_start_input_date: startInputDate,
            start_excel_date: getExcelDate(formData?.start_date),
            end_excel_date: getExcelDate(formData?.end_date),
            today_iso_date: getISOFormattedDate(),
            yesterday_iso_date: getISOFormattedDate(-1),
            tomorrow_iso_date: getISOFormattedDate(1),
            name: "Test",
          },
          product_details: JSON.parse(localStorage.getItem("product_details")),
        },
      },
    });
    setAskMemberDetailForm(false);
  };
  // // console.log(productContainerSideData, 'productContainerSideData');

  if (productLoader) {
    return <Loader type="logo-gif" />;
  }

  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    rtl: currentLanguage === "ar",
    responsive: [
      {
        breakpoint: 992, // Below 992px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // Below 768px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575, // Below 575px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // const images =
  //   currentLanguage === "ar"
  //     ? [Insuranceimage1, Insuranceimage2, Insuranceimage3, Insuranceimage4]
  //     : [Insuranceimage1, Insuranceimage2, Insuranceimage3, Insuranceimage4];
  const images = [
    Insuranceimage1,
    Insuranceimage3,
    Insuranceimage2,
    Insuranceimage4,
  ];

  return (
    <section className={isAllProductPage ? "insurance-product" : "Search"}>
      <div className={isAllProductPage ? "container" : "container"}>
        <div
          className={
            isAllProductPage ? "row " : "search-info row align-items-center"
          }
        >
          <div className={isAllProductPage ? "col-12" : "col-12 col-lg-9"}>
            <div
              className={isAllProductPage ? "search-box h-100" : "search-box"}
            >
              <ul
                className={
                  isAllProductPage
                    ? "flex-wrap nav nav-pills pb-0"
                    : "nav nav-pills pb-0"
                }
                id="pills-tab"
                role="tablist"
              >
                {isAllProductPage ? (
                  products && products.length ? (
                    products.map((product, index) => (
                      <ProductCard
                        product={product}
                        key={"product_" + index}
                        activeProduct={activeProduct === product?.id}
                        changeActiveProduct={handleProductClick}
                        classList={index === 0 ? " moter" : ""}
                      />
                    ))
                  ) : (
                    <NoData msg={t("noProductDetails")} />
                  )
                ) : homeProducts && homeProducts.length ? (
                  homeProducts.map((product, index) => (
                    <ProductCard
                      product={product}
                      key={"product_" + index}
                      activeProduct={activeProduct === product?.id}
                      changeActiveProduct={handleProductClick}
                      classList={index === 0 ? " moter" : ""}
                    />
                  ))
                ) : (
                  <NoData msg={t("noProductDetails")} />
                )}
              </ul>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  {subProducts && subProducts.length ? (
                    subProducts.map((subProduct, index) => (
                      <button
                        className={
                          activeSubProduct === index
                            ? "btn btn-primary m-3 active"
                            : "btn btn-primary m-3"
                        }
                        key={"sub_products_" + index}
                        onClick={() =>
                          handleSubProductClick(
                            {
                              product_id: subProduct?.product_id,
                              sub_product_id: subProduct?.id,
                            },
                            index
                          )
                        }
                      >
                        {subProduct?.sub_product_name}
                      </button>
                    ))
                  ) : (
                    <NoData msg={t("noSubProducts")} />
                  )}

                  {productDetail && productDetail?.place_to_call === "1" ? (
                    <form onSubmit={submitGetQuote}>
                      <div className="row my-3">
                        {productDetail.input_paremeter.map((item, index) =>
                          item?.input_type === "select" ? (
                            <div className="col" key={"select_item_" + index}>
                              {/* <label htmlFor={item?.input_label} className="form-label">{item?.input_label}</label> */}
                              <select
                                name={
                                  item?.input_label
                                    ? item?.input_label
                                        .replace(/\s+/g, "_")
                                        .toLowerCase()
                                    : ""
                                }
                                placeholder={item?.input_label}
                                className="form-control"
                                onChange={handleInputChange}
                                required={
                                  item?.is_mandatory === "1" ? true : false
                                }
                              >
                                {item?.country_master &&
                                item?.country_master.length > 0 ? (
                                  item?.country_master.map((opiton, index) => (
                                    <option
                                      value={opiton?.id}
                                      key={
                                        "product_input_select_option_" + index
                                      }
                                    >
                                      {opiton?.name}
                                    </option>
                                  ))
                                ) : item?.option_paremeter &&
                                  item?.option_paremeter.length ? (
                                  item?.option_paremeter.map(
                                    (opiton, index) => (
                                      <option
                                        value={opiton?.option_value}
                                        key={
                                          "product_input_select_option_" + index
                                        }
                                      >
                                        {opiton?.option_label}
                                      </option>
                                    )
                                  )
                                ) : (
                                  <option value={item?.input_label}>
                                    {item?.input_label}
                                  </option>
                                )}
                              </select>
                            </div>
                          ) : (
                            <div className="col" key={"input_item_" + index}>
                              {/* <label htmlFor={item?.input_label} className="form-label">{item?.input_label}</label> */}
                              <input
                                type={item?.input_type}
                                name={
                                  item?.input_label
                                    ? item?.input_label
                                        .replace(/\s+/g, "_")
                                        .toLowerCase()
                                    : ""
                                }
                                placeholder={item?.input_label}
                                className="form-control"
                                onChange={handleInputChange}
                                required={
                                  item?.is_mandatory === "1" ? true : false
                                }
                              />
                            </div>
                          )
                        )}
                        <button type="submit" className="btn btn-primary my-3">
                          {t("getQuote")}
                        </button>
                      </div>
                    </form>
                  ) : productDetail?.place_to_call === "0" ? (
                    <NoData msg={t("noInputParameterFound")} />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={isAllProductPage ? "d-none" : "col-12 col-lg-3"}>
            <div
              className="insurance_slider"
              dir={currentLanguage === "ar" ? "rtl" : "ltr"}
            >
              <Slider {...settings}>
                {images.map((img, index) => (
                  <div key={index}>
                    <div className="image-slider">
                      <Image
                        src={img}
                        alt={`insurance_image_${index + 1}`}
                      />
                      <div className="image-content">
                        <h4>{t("home_slide.slide" + (index + 1) + ".title")} <br />
                        <span>{t("home_slide.slide" + (index + 1) + ".description")}</span></h4>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>

      <DynamicFormModal
        show={askMemberDetailForm}
        handleClose={setAskMemberDetailForm}
        handleSubmit={handleAskMemberDetailFormSubmit}
        inputParameters={askMemberDetailFormData}
        noOfData={parseInt(formData.no_of_persons)}
      />
    </section>
  );
};

export default ProductContainer;
